export default __webpack_public_path__ + "static/media/white-now-pep-logo.ac5a63ed.svg";